import { camelCase } from '@cc-shopping/utils/string/camelCase';
import type { MarketplaceEntity } from '../types';
import type { MarketplaceDriverConfig } from './types';

export const getDriverIntroApr = (
  marketplaceEntity: MarketplaceEntity,
): MarketplaceDriverConfig | null => {
  if (!marketplaceEntity.driverIntroApr) return null;
  return {
    id: camelCase(marketplaceEntity.driverIntroApr.label),
    label: marketplaceEntity.driverIntroApr.label,
    value: marketplaceEntity.driverIntroApr.value,
    description: undefined,
    labelTooltip: undefined,
    valueTooltip: undefined,
    valueTooltipHasHtml: false,
  };
};
